import { proNavigator } from "single-spa/react-app/ProNavigator";
import type { Integration } from "app/pages/sales-intelligence/sub-modules/management/types";

export const getIntegrationNameFromUrl = (): { integrationName: Integration | undefined } => {
    const { url } = proNavigator.current();
    const integrationName = url && url.split("/")[2] ? (url.split("/")[2] as Integration) : undefined;

    return { integrationName };
};
